import { Stack, Card, useTheme, Typography } from "@mui/material";

import { VehicleImage } from "./vehicle-images";
import { VehicleInfo } from "./vehicle-info";
import { VehicleFeatures } from "./vehicle-features";
import { VehicleActions } from "./vehicle-actions";

interface VehicleCardProps {
  vehicle: {
    id: number;
    isSold?: boolean;
    image: string;
    name: string;
    price: string;
    categories?: string;
    category?: {
      id: number;
      name: string;
      image: string;
      parentCategoryId: null | number;
    };
    transmission?: string;
    fuelType?: string;
    engineType?: string;
    brand?: string;
    model?: string;
    driven?: string;
  };
  type?: string;
  selectedCardId?: number | null;
  onSelect?: (id: number) => void;
  onViewDetails?: (vehicleId: number) => void;
}

const VehicleCard = ({
  vehicle,
  onSelect,
  onViewDetails,
  type,
}: VehicleCardProps) => {
  const theme = useTheme();

  return (
    <Stack
      minWidth={{ xs: "200px", md: "240px" }}
      width={{ xs: "300px", sm: "100%" }}
      height={"auto"}
      sx={{
        backgroundColor: theme.palette.grey[100],
        px: 2,
        borderRadius: 2,
        overflow: "hidden",
        maxWidth: { xs: 250, sm: 283 },
      }}
    >
      <Card
        onClick={() => onSelect && onSelect(vehicle?.id)}
        sx={{
          transition: "all 0.3s ease",
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          backgroundColor: "transparent",
          boxShadow: "none",
          borderRadius: 0,
        }}
      >
        {type && (
          <Stack
            sx={{
              position: "absolute",
              top: 25,
              right: 8,
              backgroundColor: type === "Buy" ? "#EBC5E6" : "#FFDFB3",
              color: type === "Buy" ? "#89326B " : "#985902",
              px: 2,
              py: 0.2,
              borderRadius: "5px",
              fontSize: 12,
              fontWeight: 600,
              fontFamily: "Work Sans",
            }}
          >
            {type}
          </Stack>
        )}
        <VehicleImage
          src={vehicle?.image}
          alt={vehicle?.name}
          statusTag={vehicle?.isSold ? "SOLD" : undefined}
        />

        <VehicleInfo
          name={`${vehicle?.brand || ""} ${vehicle?.model || ""}`.trim()}
          vehicle={vehicle}
        />
        <VehicleFeatures
          gearType={vehicle?.transmission}
          fuelType={vehicle?.engineType}
          kmDriven={vehicle?.driven}
        />

        <Typography
          fontWeight="600"
          sx={{
            color: theme.palette.primary.main,
            fontSize: { xs: 14, sm: 18 },
            mt: { xs: 1, sm: 0 },
          }}
        >
          {vehicle?.price &&
            Number(vehicle.price).toLocaleString("en-IN", {
              currency: "INR",
              style: "currency",
              maximumFractionDigits: 0,
            })}
        </Typography>

        <VehicleActions onViewDetails={() => onViewDetails?.(vehicle?.id)} />
      </Card>
    </Stack>
  );
};

export { VehicleCard };
